import api from '../utils/api';
import { ClientCommunication } from '../components/ClientCommunication/ClientCommunicationDialog';

export const clientCommunicationService = {
  async getByHorseId(horseId: string): Promise<ClientCommunication[]> {
    const response = await api.get(`/client-communications?horseId=${horseId}`);
    return response.data;
  },

  async create(data: Omit<ClientCommunication, 'id'>): Promise<ClientCommunication> {
    const response = await api.post('/client-communications', data);
    return response.data;
  },

  async update(id: string, data: Partial<ClientCommunication>): Promise<ClientCommunication> {
    const response = await api.patch(`/client-communications/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/client-communications/${id}`);
  },
};

